import { SERVICE_OGP_IMAGE, SITE_URL } from '../../constants'
import { withFaqPageSchema } from '../../builders/faq'
import { buildServiceSchema } from '../../builders/service'
import { aiDrivenDevelopmentFaqItems } from '../../data/faqs/ai-driven-development'
import { PageMeta } from '../../types'

const description =
  'クラウドネイティブ基盤とデザインシステムに、Cursor・Windsurf・Devin などのAI開発エージェントを掛け合わせ、次世代型のモダナイズ開発スタイルを実現します。実績豊富なスクラムチームに、AIで強化されたモダンスタック人材データベースを組み込み、内製化と自動化を強力に推進します。'

export const aiDrivenDevelopmentPageMeta: PageMeta = {
  title: 'AI駆動開発支援 | サービス | i3DESIGN アイスリーデザイン',
  description,
  keyword:
    'AI駆動開発 支援 AI エージェント 開発 モダナイゼーション モダンスタック プラットフォームエンジニアリング CI/CD DevOps',
  image: SERVICE_OGP_IMAGE,
  url: `${SITE_URL}/services/ai-driven-development/`,
}

const aiDrivenDevelopmentServiceSchema = buildServiceSchema({
  slug: 'ai-driven-development',
  name: 'AI駆動開発支援',
  description: aiDrivenDevelopmentPageMeta.description,
  serviceType: 'AI駆動開発支援',
  category: 'モダンアプリケーション開発',
  offerCatalogName: 'AI駆動開発支援サービス',
  breadcrumbName: 'AI駆動開発支援',
  offers: [
    {
      name: 'AIエージェント導入支援',
      description:
        '各種AIエージェントを活用して開発プロセスを効率化し、品質向上とコスト削減を実現。既存のソースコードやドキュメントのAI解析による現状把握を起点に、AIエージェントによる開発スピードの向上、単体テストからE2EテストへのAI適用までを支援します。',
    },
    {
      name: 'クラウドネイティブ開発支援',
      description:
        '最新のクラウド技術を活用し、スケーラブルで柔軟なシステム構築を支援。AWS、Azure、GCPなどの主要プラットフォームに対応し、コンテナ技術やマイクロサービスアーキテクチャの設計・実装までを一貫してサポートします。',
    },
    {
      name: 'DevOps & CI/CD構築支援',
      description:
        'GitLab CI, GitHub Actionsなどのツール導入とパイプライン設計をはじめ、テストやデプロイの自動化によってリリースサイクルの高速化を支援。セキュリティを考慮したDevSecOpsの実践までをカバーします。',
    },
    {
      name: 'スクラムチーム編成 & マネジメント',
      description:
        '効果的なアジャイル開発を実現するチーム構築と運営をサポート。スクラムマスターやプロダクトオーナーのアサインに加え、チーム立ち上げから運営までの伴走支援を提供し、プロセスの最適化と定着化を支援します。',
    },
  ],
})

export const aiDrivenDevelopmentSchema = withFaqPageSchema(
  aiDrivenDevelopmentServiceSchema,
  aiDrivenDevelopmentPageMeta.url,
  aiDrivenDevelopmentFaqItems,
)
